module.exports = __webpack_public_path__ + "img/people_img_6_2.cd090dc9.png";